/**
 * P1-07: IconStat —— 图标 + 数值 + tooltip 的通用小部件。
 *
 * toolbar 各指示器（happiness/energy/pollution/sorrow/fps）复用。
 * 对齐旧 WToolbarIconContainer（js/jsx/toolbar.jsx.js:8-29）：
 * - 输出 `toolbarIcon` 旧 class 钩子（+ 各指示器语义 class），
 *   使 28 套主题的既有覆盖规则（如 theme_minimalist.css:287-348）继续命中；
 * - 图标由旧 CSS 背景 SVG 提供（.toolbarIcon.happiness/.energy 等），
 *   本组件只负责结构、数据与 tooltip。
 */
import type { ReactNode } from "react";
import { TooltipAnchor } from "./Tooltip/TooltipProvider";

export interface IconStatProps {
  /** 旧 class 钩子，如 "happiness"、"energy warning"、"sorrow max" */
  className?: string;
  /** tooltip 内容生成器；缺省则无 tooltip（对齐旧行为） */
  getTooltip?: () => string;
  children?: ReactNode;
}

export function IconStat({ className = "", getTooltip, children }: IconStatProps) {
  return (
    <TooltipAnchor getTooltip={getTooltip} className={`toolbarIcon ${className}`.trim()}>
      {children}
    </TooltipAnchor>
  );
}
